<mat-nav-list [class.mobile]="isMobile">
  @if (isMobile) {
    <div class="mobile-block">
      <button mat-button type="button" [matMenuTriggerFor]="gamesMenu">
        {{ mapper[gameType] | translate }}
      </button>
    </div>
    <mat-divider></mat-divider>
  }
  @if (userRole && userRole !== roles.User) {
    @for (
      item of menuItemsByType[gameType];
      track item.url + item.name + i;
      let i = $index
    ) {
      @if (item.permission.includes(userRole)) {
        @if (item.name === dividerName) {
          <mat-divider></mat-divider>
        } @else {
          <a
            mat-list-item
            routerLinkActive="active-link"
            class="sidenav-menu-item"
            [routerLink]="item.url"
            [routerLinkActiveOptions]="{ exact: true }">
            <span class="menu-item-content">
              <img
                [src]="'assets/menu-icons/' + item.icon + '.svg'"
                [title]="item.name | translate"
                [alt]="item.icon" />
              @if (isSidenavOpen) {
                <span class="menu-item-name text-body-1">{{
                  item.name | translate
                }}</span>
              }
            </span>
          </a>
        }
      }
    }
  }
</mat-nav-list>

<mat-menu #gamesMenu="matMenu">
  <mat-action-list class="clients-list">
    @for (game of games$ | async; track game.type) {
      <button mat-menu-item (click)="onSetGameType(game.type)">
        <span>{{ game.title | translate }}</span>
      </button>
    }
  </mat-action-list>
</mat-menu>
